const getParentsTransformShift = (node) => {
  const offset = {
    x: 0,
    y: 0,
  };

  let element = node;

  while (element) {
    const { transform } = getComputedStyle(element);

    if (transform !== 'none') {
      const { x, y } = element.getBoundingClientRect();
      offset.x = x;
      offset.y = y;
      element = null;
    } else {
      element = element.parentElement;
    }
  }

  return offset;
};

export default getParentsTransformShift;
